/* ============================================================
   BESPOKE PAGE — bespoke-animations.js
   Hero entrance: exact mirror of initHeroEntrance() in animations.js
     - Background panel clip-path wipe (expo.inOut, 1.1s)
     - Circle breathes in from scale 0.55
     - Eyebrow slides from left
     - Headline: SplitText by lines, each line slams up through mask
       (yPercent 110→0, stagger 0.18, power3.out) — fires at 0.5s
     - Gold rule draws
     - Sub fades up
     - Scroll hint fades
   All deferred through whenLoaderDone() (= afterLoader equivalent).
   Philosophy: SplitText two-beat word reveal, gold lines draw.
   Trail thread: GSAP scrub draws SVG path smoothly.
   ============================================================ */
(function () {
  'use strict';

  var hasBh    = !!document.querySelector('[data-bh]');
  var hasBph   = !!document.querySelector('[data-bph]');
  var hasBtrail = !!document.querySelector('.btrail');
  if (!hasBh && !hasBph && !hasBtrail) return;

  function tryInit() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof SplitText === 'undefined') {
      setTimeout(tryInit, 50); return;
    }
    gsap.registerPlugin(ScrollTrigger, SplitText);
    run();
  }

  function whenLoaderDone(fn) {
    if (document.body.classList.contains('tcc-loaded')) { fn(); return; }
    var obs = new MutationObserver(function () {
      if (document.body.classList.contains('tcc-loaded')) { obs.disconnect(); fn(); }
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function run() {

    /* ── Progress bar ── */
    var prog = document.getElementById('bsp-prog');
    if (prog) {
      ScrollTrigger.create({
        start: 0, end: 'max', scrub: 0,
        onUpdate: function (self) { prog.style.width = (self.progress * 100) + '%'; }
      });
    }

    /* ================================================================
       HERO — identical to initHeroEntrance() in animations.js
    ================================================================ */
    if (hasBh) {
      var hero      = document.querySelector('[data-bh]');
      var eyebrow   = hero.querySelector('[data-bh-eyebrow]');
      var headline  = hero.querySelector('[data-bh-headline]');
      var rule      = hero.querySelector('[data-bh-rule]');
      var sub       = hero.querySelector('[data-bh-sub]');
      var scrollHint = hero.querySelector('[data-bh-scroll]');
      var circle    = hero.querySelector('[data-bh-circle]');
      var panel     = hero.querySelector('.bh__panel');
      var bgLine    = hero.querySelector('.bh__bg-line');
      var wm        = document.getElementById('bhWm');

      /* Initial states — set BEFORE loader wipes */
      if (circle)  { gsap.set(circle,  { scale: 0.55, opacity: 0 }); }
      if (eyebrow) { gsap.set(eyebrow, { opacity: 0, x: -18 }); }
      if (rule)    { gsap.set(rule,    { width: 0, opacity: 0 }); }
      if (sub)     { gsap.set(sub,     { opacity: 0, y: 16 }); }
      if (scrollHint) { gsap.set(scrollHint, { opacity: 0 }); }

      /* Split headline BEFORE loader — masks exist, words hidden */
      var heroSplit = null;
      if (headline) {
        gsap.set(headline, { opacity: 1 });
        heroSplit = new SplitText(headline, { type: 'lines', linesClass: 'bh-split-line' });
        heroSplit.lines.forEach(function (line) {
          var wrap = document.createElement('div');
          wrap.style.cssText = 'overflow:hidden;display:block;';
          line.parentNode.insertBefore(wrap, line);
          wrap.appendChild(line);
        });
        gsap.set(heroSplit.lines, { yPercent: 110, opacity: 0 });
      }

      /* Watermark parallax */
      if (wm) {
        ScrollTrigger.create({
          trigger: hero, start: 'top top', end: 'bottom top', scrub: 1.5,
          onUpdate: function (self) { gsap.set(wm, { x: self.progress * -60 }); }
        });
      }

      whenLoaderDone(function () {
        var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        /* 1. Circle breathes in */
        if (circle) tl.to(circle, { scale: 1, opacity: 0.35, duration: 1.6, ease: 'power2.out' }, 0);

        /* 2. Panel wipes up — exactly like homepage video panel */
        if (panel) {
          gsap.set(panel, { clipPath: 'inset(100% 0 0 0)' });
          tl.to(panel, { clipPath: 'inset(0% 0 0 0)', duration: 1.1, ease: 'expo.inOut' }, 0);
        }

        /* 3. Deco line draws */
        if (bgLine) {
          tl.to(bgLine, { scaleY: 1, opacity: 0.6, duration: 1.4, ease: 'power2.out' }, 0.15);
        }

        /* 4. Eyebrow slides in */
        if (eyebrow) tl.to(eyebrow, { opacity: 1, x: 0, duration: 0.6 }, 0.3);

        /* 5. Headline — line by line slam (identical to homepage) */
        if (heroSplit && heroSplit.lines.length) {
          tl.to(heroSplit.lines, {
            yPercent: 0,
            opacity: 1,
            duration: 0.85,
            stagger: 0.18,
            ease: 'power3.out'
          }, 0.5);
        }

        /* 6. Rule draws */
        if (rule) tl.to(rule, { width: 'clamp(40px,6vw,64px)', opacity: 1, duration: 0.6, ease: 'power2.inOut' }, 1.2);

        /* 7. Sub fades */
        if (sub) tl.to(sub, { opacity: 1, y: 0, duration: 0.6 }, 1.35);

        /* 8. Scroll hint */
        if (scrollHint) tl.to(scrollHint, { opacity: 0.65, duration: 0.5 }, 1.55);
      });
    }

    /* ================================================================
       PHILOSOPHY — two-beat word reveal, gold lines draw
    ================================================================ */
    if (hasBph) {
      var bph   = document.querySelector('[data-bph]');
      var lineL = bph.querySelector('[data-bph-line-l]');
      var lineR = bph.querySelector('[data-bph-line-r]');
      var label = bph.querySelector('[data-bph-label]');
      var quote = bph.querySelector('[data-bph-quote]');
      var attr  = bph.querySelector('[data-bph-attr]');

      if (lineL) gsap.set(lineL, { scaleY: 0, transformOrigin: 'top center' });
      if (lineR) gsap.set(lineR, { scaleY: 0, transformOrigin: 'top center' });

      if (quote) {
        gsap.set(quote, { opacity: 1 });
        var s = new SplitText(quote, { type: 'words', wordsClass: 'bph-word' });
        s.words.forEach(function (w) {
          var mask = document.createElement('span');
          mask.style.cssText = 'display:inline-block;overflow:hidden;vertical-align:bottom;padding-bottom:0.04em;';
          w.parentNode.insertBefore(mask, w);
          mask.appendChild(w);
        });
        gsap.set(s.words, { yPercent: 110 });

        var beat1 = [], beat2 = [], inB2 = false;
        s.words.forEach(function (w) {
          if (inB2) { beat2.push(w); return; }
          beat1.push(w);
          if (w.textContent.trim().slice(-1) === '.') inB2 = true;
        });

        ScrollTrigger.create({
          trigger: bph, start: 'top 72%', once: true,
          onEnter: function () {
            var tl = gsap.timeline();
            if (lineL) tl.to(lineL, { scaleY: 1, duration: 1.1, ease: 'power2.out' }, 0);
            if (lineR) tl.to(lineR, { scaleY: 1, duration: 1.1, ease: 'power2.out' }, 0.08);
            if (label) { gsap.set(label, { opacity: 0 }); tl.to(label, { opacity: 0.8, duration: 0.5, ease: 'power3.out' }, 0.2); }
            if (beat1.length) tl.to(beat1, { yPercent: 0, duration: 0.65, stagger: 0.04, ease: 'expo.out' }, 0.3);
            var b1end = 0.3 + beat1.length * 0.04 + 0.65;
            if (beat2.length) tl.to(beat2, { yPercent: 0, duration: 0.65, stagger: 0.04, ease: 'expo.out' }, b1end + 0.28);
            if (attr) tl.to(attr, { opacity: 1, duration: 0.5 }, b1end + 0.8);
          }
        });
      }
    }

    if (!hasBtrail) return;

    /* ================================================================
       TRAIL SECTION HEADER
    ================================================================ */
    var trailHeader = document.getElementById('btrailHeader');
    if (trailHeader) {
      var thEy     = document.getElementById('bthEyebrow');
      var thInners = trailHeader.querySelectorAll('.btrail__h2-inner');
      var thSub    = document.getElementById('bthSub');
      var thDone   = false;

      if (thEy)  gsap.set(thEy,  { opacity: 0, y: 14 });
      if (thSub) gsap.set(thSub, { opacity: 0, y: 12 });
      thInners.forEach(function (l) { gsap.set(l, { yPercent: 110 }); });

      ScrollTrigger.create({
        trigger: trailHeader, start: 'top 75%', once: true,
        onEnter: function () {
          if (thDone) return; thDone = true;
          var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
          if (thEy) tl.to(thEy, { opacity: 1, y: 0, duration: 0.55 }, 0);
          thInners.forEach(function (l, i) {
            tl.to(l, { yPercent: 0, duration: 0.82 }, 0.1 + i * 0.14);
          });
          if (thSub) tl.to(thSub, { opacity: 1, y: 0, duration: 0.6 }, 0.45);
        }
      });
    }

    /* ── Interlude texts ── */
    document.querySelectorAll('[data-btrail-interlude]').forEach(function (el) {
      gsap.set(el, { opacity: 0 });
      ScrollTrigger.create({
        trigger: el, start: 'top 80%', once: true,
        onEnter: function () { gsap.to(el, { opacity: 1, duration: 0.5 }); }
      });
    });

    /* Register interlude Y positions for dot-proximity flash in buildThread */
    window._btrailInterludeAnchors = [];

    /* ── Cards ── */
    var cardObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !e.target.dataset.done) {
          e.target.dataset.done = '1';
          e.target.classList.add('is-in');
          var idx = parseInt(e.target.id.replace('btrailCard', ''), 10);
          var nd = document.getElementById('btrailNode' + idx);
          if (nd) gsap.to(nd, { opacity: 1, duration: 0.4 });
        }
      });
    }, { threshold: 0.14 });
    document.querySelectorAll('.btrail__card').forEach(function (c) { cardObs.observe(c); });

    /* ── Materials ── */
    var matSec = document.getElementById('btrailMaterials');
    if (matSec) {
      ScrollTrigger.create({
        trigger: matSec, start: 'top 78%', once: true,
        onEnter: function () {
          var ey = document.getElementById('btrailMatEyebrow');
          if (ey) { gsap.set(ey, { opacity: 0, x: -16 }); gsap.to(ey, { opacity: 1, x: 0, duration: 0.55, ease: 'power3.out' }); }
          matSec.querySelectorAll('[data-btrail-mat]').forEach(function (m) { m.classList.add('is-in'); });
        }
      });
    }

    /* ── CTA ── */
    var ctaSec = document.getElementById('btrailCta');
    if (ctaSec) {
      var ctaGhost = document.getElementById('btrailCtaGhost');
      ScrollTrigger.create({
        trigger: ctaSec, start: 'top 80%', once: true,
        onEnter: function () {
          ['btrailCtaEyebrow','btrailCtaH2','btrailCtaCopy','btrailCtaRight'].forEach(function (id) {
            var el = document.getElementById(id); if (el) el.classList.add('is-in');
          });
          if (ctaGhost) ctaGhost.classList.add('is-in');
        }
      });
      if (ctaGhost) {
        gsap.set(ctaGhost, { x: 80 });
        ScrollTrigger.create({
          trigger: ctaSec, start: 'top bottom', end: 'bottom top', scrub: 2,
          onUpdate: function (self) { gsap.set(ctaGhost, { x: 80 - self.progress * 150 }); }
        });
      }
    }

    /* ================================================================
       OPTION D — TRAVELLING DOT along bezier snake path
       - Anchors placed on the COPY side of each card (not centre)
         so the path runs through text panels, never over images
       - Ghost dashed path always faintly visible as a guide
       - Gold dot + glow halo positioned via getPointAtLength() every frame
       - ScrollTrigger maps section scroll → path progress (0→1)
       - GSAP scrub:2 gives the dot a slight lag — feels alive
       - Dot fades in once progress > 0, fades out at end
       - Nodes light up as the dot passes each anchor
    ================================================================ */
    var pathEl   = document.getElementById('btrailDash'); /* guide path */
    var dotEl    = document.getElementById('btrailDot');
    var dotGlow  = document.getElementById('btrailDotGlow');
    var pathLen  = 0;
    var anchors  = [];
    var thresholds = [];

    function buildThread() {
      var section = document.getElementById('btrailSection');
      var svg     = document.getElementById('btrailSvg');
      if (!section || !svg || !pathEl) return;

      var cards = [0,1,2,3,4].map(function (i) { return document.getElementById('btrailCard' + i); });
      if (!cards[0]) return;

      var scrollY = window.pageYOffset;
      var secTop  = section.getBoundingClientRect().top + scrollY;
      var secH    = section.offsetHeight;

      /* Anchor = centre of the COPY column of each card.
         Odd cards are right-swing: copy is left column (order:1).
         Even are left-swing: copy is right column (order:2).
         In practice we target 75% of card width for left-swing cards
         and 25% for right-swing, centred vertically.                  */
      var isMobileLayout = window.innerWidth < 800;
      anchors = cards.map(function (card, i) {
        if (!card) return { x: window.innerWidth * 0.5, y: 400 };
        var r = card.getBoundingClientRect();
        var isRight = card.classList.contains('btrail__card--right');
        /* On mobile cards are single column — keep dot centred */
        var cx = isMobileLayout
          ? window.innerWidth * 0.5
          : (isRight ? r.left + r.width * 0.25 : r.left + r.width * 0.75);
        var cy = (r.top + scrollY) - secTop + r.height * 0.5;
        return { x: cx, y: cy };
      });

      /* Build bezier snake: entry at top-centre → through each card copy column → exit at bottom-centre */
      var centreX = window.innerWidth * 0.5;
      var headerEl = document.getElementById('btrailHeader');
      var entryY   = 0;
      if (headerEl) {
        var hR   = headerEl.getBoundingClientRect();
        var secR = section.getBoundingClientRect();
        entryY   = (hR.top - secR.top) + hR.height * 0.5;
      }
      var entry  = { x: centreX, y: entryY };
      var exit   = { x: centreX, y: secH };
      var allPts = [entry].concat(anchors).concat([exit]);

      var d = 'M ' + allPts[0].x.toFixed(1) + ' ' + allPts[0].y.toFixed(1);
      for (var i = 1; i < allPts.length; i++) {
        var p = allPts[i-1], q = allPts[i];
        var dy = (q.y - p.y) * 0.45;
        d += ' C ' + p.x.toFixed(1) + ' ' + (p.y + dy).toFixed(1) +
             ' '   + q.x.toFixed(1) + ' ' + (q.y - dy).toFixed(1) +
             ' '   + q.x.toFixed(1) + ' ' + q.y.toFixed(1);
      }

      /* Apply path to all three SVG path elements */
      ['btrailDash','btrailSolid','btrailGlow'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.setAttribute('d', d);
      });

      pathLen = pathEl.getTotalLength();

      /* Position nodes at anchor points */
      anchors.forEach(function (a, i) {
        var nd = document.getElementById('btrailNode' + i);
        if (nd) { nd.style.left = a.x.toFixed(1) + 'px'; nd.style.top = a.y.toFixed(1) + 'px'; }
      });

      /* No node thresholds needed — dot is sole indicator */

      svg.setAttribute('viewBox', '0 0 ' + window.innerWidth + ' ' + secH);
      svg.style.height = secH + 'px';

      /* ── Create spotlight overlay ── */
      var spotlight = document.getElementById('btrailSpotlight');
      if (!spotlight) {
        spotlight = document.createElement('div');
        spotlight.id = 'btrailSpotlight';
        spotlight.setAttribute('aria-hidden', 'true');
        spotlight.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:3;mix-blend-mode:overlay;opacity:1;background:rgba(0,0,0,0.88);will-change:background,opacity;';
        section.style.position = 'relative';
        section.insertBefore(spotlight, section.firstChild);
      }
      window._btrailSpotlight = spotlight;

      /* Build interlude Y anchors for dot-proximity flash */
      var intAnchors = [];
      document.querySelectorAll('[data-btrail-interlude]').forEach(function (el) {
        var r    = el.getBoundingClientRect();
        var secR = section.getBoundingClientRect();
        intAnchors.push({ el: el, y: (r.top - secR.top) + r.height * 0.5, lit: false, _t: null });
      });
      window._btrailInterludeAnchors = intAnchors;

      if (window._btrailST) { window._btrailST.kill(); window._btrailST = null; }

      /* Trigger: starts exactly when card 0 top hits 80% of viewport,
         ends exactly when card 4 bottom hits 20% of viewport.
         This means the dot is at anchor[0] the moment you first see card 1,
         and disappears just as card 5 leaves the screen. */
      var card0 = document.getElementById('btrailCard0');
      var card4 = document.getElementById('btrailCard4');
      if (!card0 || !card4 || pathLen === 0) return;

      /* Hide dot offscreen initially */
      if (dotEl)   { dotEl.setAttribute('cx', '-200'); dotEl.setAttribute('cy', '-200'); dotEl.style.opacity = '0'; }
      if (dotGlow) { dotGlow.setAttribute('cx', '-200'); dotGlow.setAttribute('cy', '-200'); dotGlow.style.opacity = '0'; }

      /* ── Card-aware scroll→path mapping ──────────────────────────────────
         For each card we compute two values:
           scrollFrac[i]  = the rawProg (0→1 over section scroll) at which
                            that card's vertical centre is exactly at viewport centre.
           pathFrac[i]    = the path fraction (0→1) that puts the dot at that
                            card's anchor point.

         During onUpdate we linearly interpolate between these key-frames so
         the spotlight is guaranteed to sit dead-centre on each card at the
         exact moment the card is viewport-centred.  Between cards the dot
         moves smoothly as before.  The scrub is reduced slightly on the last
         segment so there is no perceptible lag on card 4.
      ──────────────────────────────────────────────────────────────────── */
      var vh   = window.innerHeight;
      var totalTravel = secH + vh; /* section travels this many px past viewport */

      /* scrollFrac for each anchor:
         The section's top is at +vh when trigger fires (start:'top bottom').
         When anchor[i].y within the section is at viewport centre:
           section.top = vh/2 - anchors[i].y
         rawProg = distance_scrolled / totalTravel
                 = (vh - (vh/2 - anchors[i].y)) / totalTravel
                 = (vh/2 + anchors[i].y)        / totalTravel              */
      var scrollFracs = anchors.map(function (a) {
        return Math.max(0, Math.min(1, (vh / 2 + a.y) / totalTravel));
      });

      /* pathFrac for each anchor point on the bezier */
      /* We find the path fraction by bisecting for the closest point */
      function pathFracForAnchor(ax, ay) {
        var best = 0, bestDist = Infinity;
        var steps = 200;
        for (var s = 0; s <= steps; s++) {
          var f  = s / steps;
          var pt = pathEl.getPointAtLength(f * pathLen);
          var dx = pt.x - ax, dy = pt.y - ay;
          var d2 = dx * dx + dy * dy;
          if (d2 < bestDist) { bestDist = d2; best = f; }
        }
        return best;
      }
      var pathFracs = anchors.map(function (a) { return pathFracForAnchor(a.x, a.y); });

      /* Hold: keep dot at path start until the entryY point is viewport-centred */
      var HOLD = Math.max(0, Math.min(0.8, (vh / 2 + entryY) / totalTravel));

      /* Map rawProg → path prog using card key-frames */
      function cardAwareProg(rawProg) {
        if (rawProg < HOLD) return 0;
        /* Build key-frame pairs: [rawProg, pathFrac] */
        var keys = [[HOLD, 0]];
        for (var i = 0; i < scrollFracs.length; i++) {
          keys.push([scrollFracs[i], pathFracs[i]]);
        }
        keys.push([1, 1]);
        /* Find the segment rawProg falls in and lerp */
        for (var k = 1; k < keys.length; k++) {
          if (rawProg <= keys[k][0]) {
            var t = (rawProg - keys[k-1][0]) / (keys[k][0] - keys[k-1][0]);
            return keys[k-1][1] + t * (keys[k][1] - keys[k-1][1]);
          }
        }
        return 1;
      }

      window._btrailST = ScrollTrigger.create({
        trigger: section,
        start:   'top bottom',
        endTrigger: section,
        end:     'bottom top',
        scrub:   0.35,   /* reduced from 0.6 — tighter follow, eliminates last-card overshoot */
        onUpdate: function (self) {
          if (!pathEl || pathLen === 0) return;
          var rawProg = self.progress;

          /* Card-aware mapping ensures spotlight centres on each card exactly
             when that card is centred in the viewport. */
          var prog = cardAwareProg(rawProg);

          /* Position dot on path */
          var pt = pathEl.getPointAtLength(prog * pathLen);
          if (dotEl)   { dotEl.setAttribute('cx',   pt.x.toFixed(1)); dotEl.setAttribute('cy',   pt.y.toFixed(1)); }
          if (dotGlow) { dotGlow.setAttribute('cx',  pt.x.toFixed(1)); dotGlow.setAttribute('cy',  pt.y.toFixed(1)); }

          /* Fade in based on raw progress (first 5%), out over last 5% */
          var alpha = Math.min(rawProg / 0.05, 1) * Math.min((1 - rawProg) / 0.05, 1);
          if (dotEl)   dotEl.style.opacity   = (Math.min(alpha, 1) * 0.9).toFixed(3);
          if (dotGlow) dotGlow.style.opacity = (Math.min(alpha, 1) * 0.25).toFixed(3);

          /* ── Interlude flash: gold pop as dot passes each tagline ── */
          var ias = window._btrailInterludeAnchors || [];
          for (var ii = 0; ii < ias.length; ii++) {
            var ia  = ias[ii];
            var txt = ia.el.querySelector('.btrail__interlude-text') || ia.el;
            if (Math.abs(pt.y - ia.y) < 140 && !ia.lit) {
              ia.lit = true;
              txt.classList.add('is-lit');
              clearTimeout(ia._t);
              ia._t = setTimeout(function (_txt, _ia) {
                return function () { _txt.classList.remove('is-lit'); _ia.lit = false; };
              }(txt, ia), 1600);
            }
          }

          /* ── Spotlight: radial gradient follows dot, mix-blend:overlay ── */
          var sp = window._btrailSpotlight;
          if (sp && pathLen > 0) {
            var sec = document.getElementById('btrailSection');
            var sW  = sec ? sec.offsetWidth  : window.innerWidth;
            var sH  = sec ? sec.offsetHeight : 2000;
            var pX  = ((pt.x / sW) * 100).toFixed(1) + '%';
            var pY  = ((pt.y / sH) * 100).toFixed(1) + '%';
            /* Many stops with NO fully-transparent stops — prevents premultiplied-alpha banding */
            var spR = window.innerWidth < 800 ? 340 : 700;
            sp.style.background =
              'radial-gradient(circle ' + spR + 'px at ' + pX + ' ' + pY + ',' +
              'rgba(0,0,0,0.01) 0%,'  +
              'rgba(0,0,0,0.01) 20%,' +
              'rgba(0,0,0,0.06) 30%,' +
              'rgba(0,0,0,0.16) 40%,' +
              'rgba(0,0,0,0.32) 50%,' +
              'rgba(0,0,0,0.50) 60%,' +
              'rgba(0,0,0,0.65) 70%,' +
              'rgba(0,0,0,0.76) 80%,' +
              'rgba(0,0,0,0.84) 90%,' +
              'rgba(0,0,0,0.88) 100%)';
            sp.style.opacity = (alpha * 0.95).toFixed(3);
          }
        },
        onEnter: function () { /* spotlight live — scrub handles it */ },
        onLeave: function () {
          /* Dot hides. Spotlight goes fully dark — section stays dark as it scrolls off. */
          if (dotEl)   dotEl.style.opacity   = '0';
          if (dotGlow) dotGlow.style.opacity = '0';
          var sp = window._btrailSpotlight;
          if (sp) {
            sp.style.background = 'rgba(0,0,0,0.88)';
            sp.style.opacity    = '1';
          }
        },
        onEnterBack: function () {
          /* Scrolling back in from below — spotlight opacity back to driven mode, scrub takes over */
          var sp = window._btrailSpotlight;
          if (sp) sp.style.opacity = '1';
        },
        onLeaveBack: function () {
          /* Scrolled back above section entirely — fully dark, scrub will re-open from top */
          if (dotEl)   { dotEl.style.opacity = '0'; dotEl.setAttribute('cx', '-200'); }
          if (dotGlow) { dotGlow.style.opacity = '0'; dotGlow.setAttribute('cx', '-200'); }
          var sp = window._btrailSpotlight;
          if (sp) {
            sp.style.background = 'rgba(0,0,0,0.88)';
            sp.style.opacity    = '1';
          }
        }
      });
    }

    if (document.readyState === 'complete') buildThread();
    else window.addEventListener('load', buildThread);

    var rsTimer;
    window.addEventListener('resize', function () {
      clearTimeout(rsTimer);
      rsTimer = setTimeout(function () { buildThread(); ScrollTrigger.refresh(); }, 150);
    });

  } /* end run() */

  if (document.readyState === 'complete') tryInit();
  else window.addEventListener('load', tryInit);

})();